import React from 'react';
import { motion } from 'framer-motion';
import { FlameIcon } from 'lucide-react';
import { scarcity } from '../data/offer';
export function ScarcityBar() {
  const claimed = Math.round((scarcity.total - scarcity.remaining) / scarcity.total * 100);
  return <div className="mt-8 w-full rounded-2xl bg-flame-soft p-4 text-left sm:p-5" data-id="element-37" data-mp="2l33ha6gt9suc">
      <div className="flex items-center justify-between gap-3" data-id="element-38" data-mp="2q26ex5ugowsa">
        <p className="flex items-center gap-2 font-display text-lg font-bold uppercase leading-tight text-ink sm:text-xl" data-id="element-39" data-mp="2b5p187ysv62k">
          <FlameIcon className="h-5 w-5 shrink-0 text-flame" aria-hidden="true" data-id="element-40" data-mp="2g7ee7t5l1tta" />
          Only {scarcity.remaining} spots left at the promotional price
        </p>
        <span className="shrink-0 font-display text-xl font-extrabold text-flame-dark" data-id="element-41" data-mp="274da1y0a2cs9">{claimed}%</span>
      </div>
      <div className="mt-3 h-4 w-full overflow-hidden rounded-full bg-white ring-1 ring-flame/20" role="progressbar" aria-valuenow={claimed} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots claimed" data-id="element-42" data-mp="fqh9xqkk1ah">
        <motion.div className="h-full rounded-full bg-flame" initial={{
        width: '20%'
      }} whileInView={{
        width: `${claimed}%`
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.9,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-43" data-mp="2zlt8i58l534t" />
      </div>
      <p className="mt-2 text-sm font-medium text-slate-700" data-id="element-44" data-mp="2ko0ujhiosmsq">
        {claimed}% of launch spots claimed. When they run out, the promotional price closes.
      </p>
    </div>;
}